import React from "react";
import Info from "../../assets/svg/tooltip.svg";

/**
 * Tooltip component that displays a description when hovered over.
 * @param {string} description - The text to display in the tooltip.
 * @param {string} icon - The icon to display next to the tooltip.
 * @returns {JSX.Element} The Tooltip component.
 */

interface TooltipProps {
  description: string;
  icon?: string;
}

const Tooltip = ({ description, icon = Info }: TooltipProps) => {
  return (
    <div className="relative group inline-block">
      <img src={icon} className="h-5 w-5 ml-2" alt="info" />
      <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-64 break-words whitespace-pre-line bg-black/70 text-white text-sm p-3 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
        <span>{description}</span>
      </div>
    </div>
  );
};

export default Tooltip;
